var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOnboardingPaintRollerIcon = function SvgOnboardingPaintRollerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.546 34.114v-4.383a.798.798 0 0 0-.587-.769l-29.5-7.426a1.597 1.597 0 0 1-1.205-1.507V8.671a1.597 1.597 0 0 1 1.597-1.597h3.134v1.853H2.077v10.846L32.3 27.395a1.416 1.416 0 0 1 1.07 1.371v5.348h-1.823Z",
    fill: "#002A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.985 8.927v5.77a1.507 1.507 0 0 0 1.506 1.506h51.917a1.507 1.507 0 0 0 1.507-1.506V1.757A1.506 1.506 0 0 0 58.408.25H6.491a1.507 1.507 0 0 0-1.506 1.506v7.17Z",
    fill: "#BC5C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.546 34.114h-1.883a1.055 1.055 0 0 0-1.055 1.055V69.71a1.04 1.04 0 0 0 1.055 1.04h5.65a1.055 1.055 0 0 0 1.054-1.04V35.17a1.07 1.07 0 0 0-1.054-1.055h-3.767Z",
    fill: "#5C8283"
  })));
};

export default SvgOnboardingPaintRollerIcon;